import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DAcCreateAccount.css';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import DacLoginForm from './components/DacLoginForm';
import DacRegisterForm from './components/DacRegisterForm';

// import checkboxTick from '../../resources/icons/check-box-white.svg';

import IconCreateAccount from './components/icon/create';
import IconLoginAccount from './components/icon/login';
import InjectHTML from './components/InjectHTML';
var FIELDS_PARAMS = {
  usernameMaxLength: 20,
  usernameMinLength: 3,
  firstnameMaxLength: 50,
  firstnameMinLength: 2,
  lastnameMaxLength: 50,
  lastnameMinLength: 2,
  otpRequiredLength: 6
};
var DAcCreateAccount = function DAcCreateAccount(props) {
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useLocation = useLocation(),
    search = _useLocation.search;
  var type = new URLSearchParams(search).get('type');
  var history = useHistory();
  var fields = props.fields,
    params = props.params;
  var _fields$data = fields.data,
    configuration = _fields$data.configuration,
    dictionary = _fields$data.dictionary,
    settings = _fields$data.settings;
  var apiKey = get(settings, 'apiKey.jss.value');
  var apiUrl = get(settings, 'apiUrl.jss.value');
  var showCreateAccountTab = get(configuration, 'showCreateAccountTab.jss.value', false);
  var _useState = useState(type && type === 'login' ? 'login-account' : 'create-account'),
    _useState2 = _slicedToArray(_useState, 2),
    activeTabItem = _useState2[0],
    setActiveTabItem = _useState2[1];
  var changeActiveTab = function changeActiveTab(event, tabKey) {
    event.preventDefault();
    if (tabKey !== activeTabItem) {
      setActiveTabItem(tabKey);
    }
  };
  useEffect(function () {
    var tokken = Cookies.get('token');
    if (tokken) {
      history.push(get(configuration, 'loginButton.jss.value.href'));
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-login"
  }, showCreateAccountTab ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6"
  }, ' ', /*#__PURE__*/React.createElement("h1", {
    className: "dac-login__title"
  }, get(configuration, 'accountTitle.jss.value', '')), /*#__PURE__*/React.createElement("p", {
    className: "dac-login__description"
  }, get(configuration, 'createAccountDescription.jss.value', ''))), /*#__PURE__*/React.createElement("div", {
    className: "d-none d-md-block col-12 col-md-6 col-xl-4 ml-xl-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-login__image"
  }, /*#__PURE__*/React.createElement(InjectHTML, {
    htmlString: get(configuration, 'dACIconCode.value', '')
  })))), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__form-wrap dac-login__form-wrap--tabs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-heading"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "t__list"
  }, /*#__PURE__*/React.createElement("li", {
    className: "t__item ".concat('create-account' === activeTabItem ? 'active' : ''),
    "data-tab": "1",
    onClick: function onClick(e) {
      changeActiveTab(e, 'create-account');
    },
    tabIndex: activeTabItem === 'create-account' ? -1 : 0,
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        changeActiveTab(e, 'create-account');
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "t__item-icon"
  }, /*#__PURE__*/React.createElement(IconCreateAccount, null)), getDictionaryItem(dictionary, 'createAccount')), /*#__PURE__*/React.createElement("li", {
    className: "t__item ".concat('login-account' === activeTabItem ? 'active' : ''),
    "data-tab": "2",
    onClick: function onClick(e) {
      changeActiveTab(e, 'login-account');
    },
    tabIndex: activeTabItem === 'login-account' ? -1 : 0,
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        changeActiveTab(e, 'login-account');
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "t__item-icon"
  }, /*#__PURE__*/React.createElement(IconLoginAccount, null)), getDictionaryItem(dictionary, 'AlreadyHaveGdrfaAccount')))), /*#__PURE__*/React.createElement("div", {
    className: "t-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: activeTabItem === 'create-account' ? 't-content active' : 't-content'
  }, /*#__PURE__*/React.createElement(DacRegisterForm, {
    dictionary: dictionary,
    configuration: configuration,
    apiConfig: {
      apiKey: apiKey,
      apiUrl: apiUrl
    },
    fieldsParams: FIELDS_PARAMS
  })), /*#__PURE__*/React.createElement("div", {
    className: activeTabItem === 'login-account' ? 't-content active' : 't-content'
  }, /*#__PURE__*/React.createElement(DacLoginForm, {
    dictionary: dictionary,
    configuration: configuration,
    apiConfig: {
      apiKey: apiKey,
      apiUrl: apiUrl
    },
    fieldsParams: FIELDS_PARAMS
  }))))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "dac-login__title"
  }, "Login to GDRFA account"), /*#__PURE__*/React.createElement("p", {
    className: "dac-login__description"
  }, get(configuration, 'loginDescription.jss.value', '')), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__form-wrap"
  }, /*#__PURE__*/React.createElement(DacLoginForm, {
    dictionary: dictionary,
    configuration: configuration,
    apiConfig: {
      apiKey: apiKey,
      apiUrl: apiUrl
    },
    fieldsParams: FIELDS_PARAMS
  })))));
};
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    anchorUrlParameter = _ref.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default DAcCreateAccount;
var commonStyles = "c198hgnz";
var ltrStyles = "l5o5bks";
var rtlStyles = "r1w3ys4a";